module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce-img-3.5287046f.webp";